import { Form, InputItem, Select, Button, TextareaItem } from 'dingtalk-design-mobile'
import './RightsServiceForm.less'
import { useState } from 'react'
import useHistory from '@/hooks/useHistory'
import { _legalFromApply } from '@/api/user'
import Upload from '@/components/Upload/Upload';
import { htmlEncode } from '@/utils/tool';


const RightsServiceForm = () => {

  const history = useHistory()

  const [showMask, setShowMask] = useState(false)

  const [formValue, setFormValue] = useState({
    name: '',
    mobile: '',
    workPlace: '',
    type: '',
    aidContent: '',
    money: '',
    fileIds: []
  })

  const onFinish = (res) => {
    const params = {
      ...res,
      fileIds: res.fileIds.map(item => item.fileId),
      aidContent: htmlEncode(res.aidContent)
    }
    // console.log('params', params)
    _legalFromApply(params).then(res => {
      const [d] = res
      if (d) {
        setTimeout(() => {
          history.push('/RightsServiceSuccess', 'route')
        }, 1000)
        
      }
    })
  }

  const validateMobile =  (_rule, value) => {
    const PhoneReg = /^(?:(?:\+|00)86)?1(?:(?:3[\d])|(?:4[5-7|9])|(?:5[0-3|5-9])|(?:6[5-7])|(?:7[0-8])|(?:8[\d])|(?:9[1|8|9]))\d{8}$/
    if (!value) {
      return Promise.reject(new Error('请输入手机号!'))
    }
    return PhoneReg.test(value) ? Promise.resolve() : Promise.reject(new Error('请输入正确的手机号!'))
  }

  return (
    <div className='pg-right-service-form'>
      <Form 
        name="form" 
        initialValues={formValue} 
        layout="vertical" 
        onFinish={onFinish}
      >
        <Form.Item name="name" label="姓名" rules={[{ required: true, message:'请输入姓名' }]}>
          <InputItem placeholder='请输入姓名' maxLength={10} />
        </Form.Item>
        <Form.Item name="mobile" label="手机号" rules={[{ required: true, validator: validateMobile }]}>
          <InputItem placeholder='请输入手机号' inputMode='tel' />
        </Form.Item>
        <Form.Item name="workPlace" label="工作单位（全称）" rules={[{ required: true, message:'请输入工作单位' }]}>
          <InputItem placeholder='请输入工作单位' maxLength={30} />
        </Form.Item>
        <Form.Item 
          name="type" 
          label="援助类型" 
          rules={[{ required: true, message:'请输入援助类型' }]}
        >
          <Select
            mode="single"
            placeholder="请选择"
            onVisibleChange={(val) => setShowMask(val)}
            options={[
              { label: '请求支付劳动报酬', value: '1' },
              { label: '工伤赔偿', value: '2' },
              { label: '其他诉求', value: '3' },
            ]}
          />
        </Form.Item>
        <Form.Item name="money" label="涉案标的金额（不低于3000元）" rules={[{ required: true, message:'请输入涉案标的金额' }]}>
          <InputItem placeholder='请输入涉案标的金额' type="number" maxLength={15} />
        </Form.Item>
        <Form.Item name="aidContent" label="援助描述" rules={[{ required: true, message:'请输入援助概述' }]}>
          <TextareaItem rows={4} placeholder='请输入援助概述' count={300} />
        </Form.Item>
        <Form.Item 
          name="fileIds" 
          label="资料上传" 
          rules={[{ required: true, message:'请上传资料' }]}
        >
            <Upload extra='最多上传10张图片，格式为png/jpg' max={10} />
        </Form.Item>
        <Button className='form-btn' htmlType="submit">提交申请</Button>
      </Form>
      {
        showMask && <div className='mask'></div>
      }
    </div>
  )
}

export default RightsServiceForm